import {
  GET_DATATABLE_COLUMN,
  GET_DATATABLE_ROW,
  RESET_DATA_TABLE,
  SET_FILTER_LIST_PENOMORAN,
  UPDATE_DATATABLE_COLUMN,
  UPDATE_DATATABLE_ROW,
  UPDATE_DATATABLE_TABLE_INFO,
  UPDATE_LAST_PAGE_DATATABLE,
  UPDATE_LAST_SEARCH_DATATABLE,
  UPDATE_LAST_TYPE_DATATABLE,
} from 'shared/constants/ActionTypes';

const initialState = {
  columns: [],
  rows: [],
  tableInfo: {
    count: 0,
    previous: '',
    next: '',
    limit: '',
  },
  pageNo: 0,
  pageType: '',
  pageSearch: '',
  urlFilter: '',
};

const dataTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DATATABLE_COLUMN:
      return {...state, columns: action.payload};
    case UPDATE_DATATABLE_ROW:
      return {...state, rows: action.payload};
    case UPDATE_DATATABLE_TABLE_INFO:
      return {...state, tableInfo: action.payload};
    case UPDATE_LAST_PAGE_DATATABLE:
      return {...state, pageNo: action.payload};
    case UPDATE_LAST_SEARCH_DATATABLE:
      return {...state, pageSearch: action.payload};
    case UPDATE_LAST_TYPE_DATATABLE:
      return {...state, pageType: action.payload};

    case GET_DATATABLE_COLUMN:
      return {...state};
    case GET_DATATABLE_ROW:
      return {...state};
    case RESET_DATA_TABLE:
      return {
        ...state,
        tableInfo: {count: 0, previous: '', next: '', limit: ''},
        pageNo:0
      };
    case SET_FILTER_LIST_PENOMORAN:
      return {...state, urlFilter: action.payload};
    default:
      return state;
  }
};
export default dataTableReducer;
